<template>
    <div class="modal fade" id="subscription-cancellation-modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>

                    <h4 class="modal-title">Manage Your Subscriptions</h4>
                </div>

                <div v-if="shown" class="modal-body mb-0 p-0">
                    <div v-if="step === 1">
                        <p>Do you really want to cancel?
                            <br><br>
                            Can we help you get more out of your automated growth program?<br>
                            <a class="intercom_launcher" href="#">CLICK HERE</a>
                        </p>

                        <button class="action-button btn btn-primary btn-lg" @click="goToStep(2)"
                                :disabled="!cancellationReasonsLoaded">Yes... I really want to cancel.
                        </button>
                    </div>

                    <div v-else-if="step === 2">
                        <div class="form">
                            <p>We're sorry to see you go. Will you share more about why you're leaving?</p>

                            <div class="reasons">
                                <div v-if="reasons.length > 0" v-for="reason in reasons" class="reason">
                                    <div class="radio">
                                        <label>
                                            <input type="radio" v-model="cancellationReason" name="reason"
                                                   :value="reason.cancel_reason_code"
                                                   @change="cancellationNoteRequired = reason.is_cancellation_note_required">
                                            {{ reason.cancel_reason_code }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="cancellation-notes">
                                <label>Anything else you would like to share?</label>
                                <textarea class="form-control" rows="4" v-model="cancellationNotes" maxlength="250"></textarea>
                            </div>

                            <button class="action-button btn btn-primary btn-lg" @click="confirm"
                                    :disabled="!((cancellationNoteRequired && cancellationNotes.length) || !cancellationNoteRequired)">Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getCancellationReasons} from "../../utility/api/billing/getCancellationReasons";
import {cancelPlanSubscription} from "../../utility/api/billing/cancelPlanSubscription";
import {confirmationHelper} from "../../utility/confirmationHelper";
import swal from "sweetalert2";

export default {
    name: 'cancellation-modal',
    props: {
        chargebeeProductName: {
            type: String,
            required: true,
        },
        chargebeeParentProductName: {
          type: String,
          required: false,
        },
        shown: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {
            step: 1,
            reasons: [],
            cancellationReason: '',
            cancellationNotes: '',
            cancellationNoteRequired: true,
            cancellationReasonsLoaded: false,
        };
    },
    watch: {
        shown: {
            immediate: true,
            handler(shown) {
                if (!shown) {
                    this.step = 1;
                }

                $('#subscription-cancellation-modal').modal(shown ? 'show' : 'hide');
            },
        },
    },
    methods: {
        async getReasons() {
            let product_name = this.chargebeeParentProductName ? this.chargebeeParentProductName : this.chargebeeProductName;

            return getCancellationReasons(product_name).then((data) => {
                this.reasons = data;
                this.cancellationReasonsLoaded = true;
            });
        },
        async cancelPlanSubscription({chargebee_product_name, cancellation_reason, cancellation_notes} = {}) {
            try {
                await cancelPlanSubscription({
                    chargebee_product_name,
                    cancellation_reason,
                    cancellation_notes
                });
            } catch (error) {
                await this.showCancellationErrorMessage(error.response.data.errors, error.response.data.message);
            }
        },
        showCancellationErrorMessage(error, title = 'Oh no!') {
            let message = error;
            if (typeof error === 'object') {
                message = '';

                Object.keys(error).forEach(name => {
                    error[name].forEach(error_msg => {
                        message += error_msg + "<br>";
                    });
                });
            }

            return swal.fire({
                title: title,
                html: '<p>' + message + '</p>',
                type: 'error',
                confirmButtonText: 'Ok',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-lg btn-primary',
            });
        },
        goToStep(step) {
            this.step = step;
        },
        confirm() {
            let text = "We're sorry to see you go. Your subscription will be cancelled at the end of the current month";
            confirmationHelper.warning(text, 'Are you sure?', 'OK').then((confirmed) => {
                if (confirmed) {
                    this.submit();
                }
            });
        },
        submit() {
            this.cancelPlanSubscription({
                chargebee_product_name: this.chargebeeProductName,
                cancellation_reason: this.cancellationReason,
                cancellation_notes: this.cancellationNotes
            }).then(() => {
                this.cancellationReason = '';
                this.cancellationNotes = '';
                this.$emit('hide', 'showCancellationModal');
                this.$parent.$refs.table.refresh();
            });
        },
        hideModal() {
            this.cancellationReasonsLoaded = false;
            this.$emit('hide');
        }
    },
    mounted() {
        $('#subscription-cancellation-modal')
            .on('hidden.bs.modal', () => this.hideModal())
            .on('shown.bs.modal', () => this.getReasons());
    },
};

// Intercom
// We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/koau9di8'
(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/koau9di8';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
</script>

<style lang="scss" scoped>
.modal {
    background-color: rgba(#000, 0.5);
}

.close {
    top: 14px;
    right: 20px;
}

button {
    margin-bottom: 30px;
}

.form {
    width: 60%;
    position: relative;
    margin: 0 auto;

    .reasons {
        padding: 0 80px;

        .reason {
            text-align: left;
        }
    }

    .cancellation-notes {
        padding: 0 80px;
        margin-bottom: 30px;
        text-align: left;
    }
}
</style>
